const addVideoTitles = () => {
	const video = document.querySelector('.block-hero-home__bg-video');
	const text1 = document.querySelector(
		'.block-hero-home__title-wrapper.text-1'
	);
	const text2 = document.querySelector(
		'.block-hero-home__title-wrapper.text-2'
	);
	const text3 = document.querySelector(
		'.block-hero-home__title-wrapper.text-3'
	);
	const text4 = document.querySelector(
		'.block-hero-home__title-wrapper.text-4'
	);
	const text5 = document.querySelector(
		'.block-hero-home__title-wrapper.text-5'
	);
	const heroDesc = document.querySelector(
		'.block-hero-home__title-wrapper.block-hero-home__title-wrapper--desc'
	);

	let text1ActiveAdded = false;

	const texts = [text1, text2, text3, text4];

	const waitForAnimationEnd = (element) => {
		return new Promise((resolve) => {
			const handler = () => {
				element.removeEventListener('animationend', handler);
				resolve();
			};
			element.addEventListener('animationend', handler);
		});
	};

	const startAnimationSequence = () => {
		waitForAnimationEnd(text1)
			.then(() => {
				return new Promise((resolve) => {
					setTimeout(() => {
						text1.classList.remove('active');
						resolve();
					}, 2000);
				});
			})
			.then(() => {
				text2.classList.add('active');
				return waitForAnimationEnd(text2);
			})
			.then(() => {
				text2.classList.remove('active');
				text3.classList.add('active');
				return waitForAnimationEnd(text3);
			})
			.then(() => {
				text3.classList.remove('active');
				text4.classList.add('active');
				return waitForAnimationEnd(text4);
			})
			.then(() => {
				text4.classList.remove('active');
				text5.classList.add('active');
				return waitForAnimationEnd(text5);
			})
			.then(() => {
				text5.classList.remove('active');
				heroDesc.classList.add('stay-active');
			});
	};

	video.addEventListener('timeupdate', function () {
		const currentTime = video.currentTime;
		const videoDuration = video.duration;

		// Remove 'stay-active' 2 seconds before the video ends
		if (videoDuration - currentTime <= 2) {
			heroDesc.classList.remove('stay-active');
		}

		// Detect video looping by checking for a reset in `currentTime`
		if (currentTime <= 0.1) {
			texts.forEach((text) => text.classList.remove('active'));
			text1.classList.remove('stay-active');
			heroDesc.classList.remove('stay-active');
			text1ActiveAdded = false;
			// Restart the animation sequence
			startAnimationSequence();
		}

		if (currentTime >= 1 && currentTime < 5 && !text1ActiveAdded) {
			text1.classList.add('active');
			text1ActiveAdded = true;
		}
	});

	// Initially start the animation sequence
	startAnimationSequence();
};

const controller = {
	init() {
		// addVideoTitles();
	},
	loaded() {
		addVideoTitles();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
